import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './whats-new.css';

const API_BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';

/**
 * The recorded product tour at /whats-new, played full screen. The player and
 * its screenshots come from /api/whats-new/, which needs a session like
 * /api/call, so the page only works once the person is signed in.
 */
export function WhatsNew() {
  const { t } = useTranslation('common');
  const frame = useRef<HTMLIFrameElement | null>(null);
  // A scene link such as /whats-new#maitre-ask opens the player on that scene;
  // read once, because the player writes its position back into the hash.
  const [src] = useState(
    () => `${API_BASE}/api/whats-new/index.html${window.location.hash}`,
  );

  useEffect(() => {
    const previous = document.title;
    document.title = t('whatsNewTitle');
    return () => {
      document.title = previous;
    };
  }, [t]);

  return (
    <iframe
      ref={frame}
      className="whats-new-frame"
      src={src}
      title={t('whatsNewTitle')}
      allow="fullscreen"
      // Space, arrows and F control the player as soon as it has loaded.
      onLoad={() => frame.current?.contentWindow?.focus()}
    />
  );
}
